import {useMemo} from 'react';

import {ItemsSectionConfig} from 'filters/features/FilterDialog/types';

import {useEditedFilterContext} from 'filters/features/FilterDialog/contexts/internal/EditedFilterProvider/EditedFilterProvider';

import {ActiveFiltersContent} from 'filters/features/FilterDialog/sections/ActiveFiltersSection/components/ActiveFiltersContent';
import {SectionCollapse} from 'filters/features/FilterDialog/sections/ActiveFiltersSection/components/SectionCollapse';

export const ItemsActiveFilters = ({
  collapsibleActiveFilterSection,
  overrideActiveFilterContent,
  id,
  title,
  items,
}: ItemsSectionConfig) => {
  const {filter, setFilter} = useEditedFilterContext();

  const content = useMemo(
    () =>
      overrideActiveFilterContent
        ? overrideActiveFilterContent(filter, setFilter)
        : items.map(item => {
            const value = item.getValue(filter);

            return item.getActiveFiltersContent(
              {value, setValue: value => setFilter(prev => item.onChange(prev, value))},
              {sectionId: id}
            );
          }),
    [overrideActiveFilterContent, filter, setFilter, items, id]
  );

  return (
    <SectionCollapse collapsible={collapsibleActiveFilterSection} title={title}>
      <ActiveFiltersContent content={content} />
    </SectionCollapse>
  );
};
